import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, useHistory } from "react-router-dom";

import { fetchOnboarding, fetchUser } from "../api";
import { redirectUser } from "../helpers";
import { useAuthStatus } from "../hooks";
import { OnboardingStore } from "../store/onboarding";
import { UserStore } from "src/store";

import { AvatarUploadStep } from "./avatar-upload-step";
import { TermsPrompt } from "./terms-prompt";

const OnboardingSteps = ({ match }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isAuthenticated, isValidatingAuth] = useAuthStatus();
  const onboarding = useSelector(OnboardingStore.selectors.select());
  const { user_id: userId } = onboarding;
  const user = useSelector(UserStore.selectors.selectById(userId));

  if (!isAuthenticated && !isValidatingAuth) {
    history.push("/");
  }

  useEffect(fetchOnboardingSteps, [isAuthenticated, dispatch]);
  useEffect(routeToNextStep, [onboarding, history]);
  useEffect(hydrateUser, [userId, user, dispatch]);

  return (
    <div className="flex">
      <Switch>
        <Route
          exact
          path={`${match.path}/accept-terms`}
          component={() => <TermsPrompt handleTermsAcceptance={handleTermsAcceptance} />}
        />
        <Route
          exact
          path={`${match.path}/photo`}
          component={() => <AvatarUploadStep user={user} />}
        />
      </Switch>
    </div>
  );

  function fetchOnboardingSteps() {
    if (isAuthenticated) dispatch(fetchOnboarding());
  }

  function handleTermsAcceptance() {
    dispatch(OnboardingStore.actions.update({ show_terms_of_service: false }));
  }

  function routeToNextStep() {
    if (onboarding && onboarding.id) {
      if (onboarding.show_terms_of_service) {
        return history.push({
          pathname: "/welcome/accept-terms",
          search: window.location.search,
        });
      }
      if (onboarding.show_system_check) {
        // We use pathname instead of href to keep eventual query parameters.
        window.location.pathname = "/welcome/system-check";
        return;
      }
      if (onboarding.show_avatar_upload) {
        return history.push({
          pathname: "/welcome/photo",
          search: window.location.search,
        });
      }
      redirectUser();
    }
  }

  function hydrateUser() {
    if (userId && !user) dispatch(fetchUser());
  }
};

export { OnboardingSteps };
